import { createDmScansService, type DmScansQueryConfig } from '@odo/shared-ui';
import apiV2 from '../../api/v2';
import Locals from '../../providers/Locals';

// In dev the FE runs on a different origin than the backend, so relative
// `/api/v2/...` photo paths need the base URL prefix to reach it.
const API_BASE_URL = Locals.config().base_api_url;

export const dmScansService = createDmScansService({ api: apiV2, apiBaseUrl: API_BASE_URL });

// `patient` root is load-bearing: the persister whitelist in providers/queryClient
// matches DM scan queries on this exact key shape.
export const dmScansQueryConfig: DmScansQueryConfig = {
    service: dmScansService,
    queryKeyRoot: 'patient'
};

export const { fetchDmScans, fetchDmScanDetail, fetchMorphing } = dmScansService;

export type {
    DmScanDetail,
    DmScanInstruction,
    DmScanPhoto,
    DmScanSummary,
    Morphing
} from '@odo/shared-ui';
